export const loadState = function() {
  const now = new Date()

  try {
    var serializedState = localStorage.getItem('state-tows');
    if (serializedState == null) {
      return undefined
    }

    if (now.getTime() > serializedState.expiry) {
      localStorage.removeItem('state-tows')
      return null
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}

export const saveState = function (state) {
  const now = new Date();

  try {
    state['expiry'] = now.getTime() + 86400;

    var serializedState = JSON.stringify(state);
    localStorage.setItem('state-tows', serializedState);
  } catch (err) {
    //
  }
}
